<template>
  <CourseDetailPage :key="$route.params.id" />
</template>

<script>
import CourseDetailPage from '@/components/Course/CourseDetailPage.vue';

export default {
  name: 'CoursePage',
  components: { CourseDetailPage }
};
</script>
